import { message } from "antd";
import { useEffect } from "react";
import { getAxiosError } from "./getAxiosError";

type UseErrorToastOptions = {
  isEnabled: boolean;
  error?: unknown;
  customError?: string;
  fallbackError?: string;
  onError?: (error: unknown) => void;
};

export const useErrorToast = (options: UseErrorToastOptions) => {
  const { isEnabled, error, customError, fallbackError, onError } = options;

  useEffect(() => {
    if (!isEnabled) return;

    message.error(customError ?? getAxiosError(error, fallbackError));
    onError?.(error);
  }, [isEnabled, error, customError, fallbackError, onError]);
};
